import React from "react";

const DeleteConfirmModal = ({
    isOpen,
    onCancel,
    onConfirm,
    entityName = "Record",
}) => {
    if (!isOpen) return null;

    return (
        <>
            <div className="drawer-overlay" />
            <div
                className="entity-drawer modal-popup-cls"
                style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: "20px 25px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                    // gap: "20px"
                }}
            >
                <div className=" d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                        onClick={onCancel}
                        style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            outline: "none",
                        }}
                        onFocus={(e) => e.target.blur()} // optional: removes focus highlight instantly
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                        >
                            <path
                                d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
                                stroke="black"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>
                <h3
                    style={{
                        textAlign: "left",
                        color: "#212529",
                        fontSize: "20px",
                        fontWeight: "600",
                        lineHeight: "24px",
                        fontFamily: "Montserrat",
                        marginBottom: "10px",
                        paddingTop: '20px'
                    }}
                >
                    Confirm to delete this {entityName}?
                </h3>
                {entityName === "Abbreviation" ? (<p
                    style={{
                        marginBottom: "0",
                        textAlign: "left",
                        color: "#6C757D",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        fontFamily: "Montserrat",
                        paddingBottom: '20px'
                    }}
                >
                    After deleting, this Abbreviation cannot be used to generate SKU Code.
                    Data generated before deletion will not be affected. This action cannot be undone.</p>) : (<p
                        style={{
                            marginBottom: "0",
                            textAlign: "left",
                            color: "#6C757D",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontFamily: "Montserrat",
                            paddingBottom: '20px'
                        }}
                    >
                        This action cannot be undone      </p>)}
                <div className="drawer-footer" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                    <button
                        onClick={onCancel}
                        style={{
                            display: "flex",
                            height: "34px",
                            minWidth: "100px",
                            padding: "10px 0px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                            borderRadius: "8px",
                            border: "1px solid  var(--navbar-dropdown-active, #212529)",
                            background: "var(--Background-White, #FFF)",
                            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
                            color: "var(--navbar-dropdown-active, #212529)",
                            fontFamily: "Montserrat",
                            fontSize: "12px",
                            fontWeight: 600,
                            fontStyle: "normal",
                            lineHeight: "normal",
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                    >

                        Cancel
                    </button>

                    <button
                        onClick={onConfirm}
                        style={{
                            display: "flex",
                            height: "34px",
                            minWidth: "100px",
                            padding: "10px 0px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                            borderRadius: "8px",
                            background: "var(--navbar-dropdown-active, #212529)",
                            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
                            color: "var(--Background-White, #FFF)",
                            fontFamily: "Montserrat",
                            fontSize: "12px",
                            fontWeight: 600,
                            fontStyle: "normal",
                            lineHeight: "normal",
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </>
    );
};

export default DeleteConfirmModal;